import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export default function Logo({ className, size = 'md', showText = true }: LogoProps) {
  const { theme } = useTheme();
  
  // Logo URL based on theme
  const logoUrl = theme === 'dark' 
    ? 'https://tvalgxmzomdvttzuyznf.supabase.co/storage/v1/object/public/public/logos/vitrinelogo-white.png'
    : 'https://tvalgxmzomdvttzuyznf.supabase.co/storage/v1/object/public/public/logos/vitrinelogo-black.png';

  // Increased sizes by 20%
  const logoSizes = {
    sm: 'h-10', // Was h-8
    md: 'h-12', // Was h-10
    lg: 'h-14', // Was h-12
  };

  return (
    <Link to="/" className={cn('flex items-center', className)}>
      <img 
        src={logoUrl} 
        alt="VitrineTurbo" 
        className={cn(logoSizes[size], 'w-auto')}
      />
    </Link>
  );
}